import type { Dispatch, SetStateAction } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import type { EditorState } from "../connectorManagerHelpers";

export const KitFields = ({
  editor,
  setEditor,
}: {
  editor: EditorState;
  setEditor: Dispatch<SetStateAction<EditorState>>;
}) => (
  <div className="space-y-2">
    <Label htmlFor="connector-kit-secret">
      Kit API secret {editor.connector ? "(leave blank to keep)" : ""}
    </Label>
    <Input
      id="connector-kit-secret"
      type="password"
      autoComplete="new-password"
      value={editor.secretValue}
      onChange={(e) => setEditor((s) => ({ ...s, secretValue: e.target.value, clearSecret: false }))}
      placeholder="Stored encrypted"
      disabled={editor.clearSecret}
    />
    <p className="text-xs text-muted-foreground">
      Find your API secret in Kit under Settings → Advanced → API. Used to create draft broadcasts on dispatch.
    </p>
    {editor.connector && (
      <label className="flex items-center gap-2 text-xs text-muted-foreground">
        <input
          type="checkbox"
          checked={editor.clearSecret}
          onChange={(e) => setEditor((s) => ({ ...s, clearSecret: e.target.checked, secretValue: "" }))}
        />
        Clear stored secret
      </label>
    )}

    <div className="mt-2 rounded-md border border-dashed border-border bg-muted/30 p-3">
      <div className="flex items-start justify-between gap-3">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <Label htmlFor="connector-kit-schedule" className="text-sm">
              Schedule broadcasts
            </Label>
            <span className="rounded-full border border-border bg-background px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
              Coming soon
            </span>
          </div>
          <p className="text-xs text-muted-foreground">
            Scheduled sends are reserved for a future Kit adapter phase. For now, dispatches always create
            a draft you review and send from Kit.
          </p>
        </div>
        <Switch id="connector-kit-schedule" checked={false} disabled aria-label="Schedule broadcasts (coming soon)" />
      </div>
    </div>
  </div>
);
